import { useEffect, useState } from "react";
import FilteringProps from "../filtering/balancetransaction.json";
//import SortingProps from "../sorting/";
import { setPage, setToolbarActions, toPrettyDate, useHub } from "../../../../core/Global";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import { DataTable, DataTableField } from "../../../../components/data/DataTable";
import BalanceTransaction, { BalanceTransactionParties, BalanceTransactionTypes } from "../models/BalanceTransaction ";
import TransactionForm from "../components/TransactionForm";
import Modal from "../../../../components/base/Modal";
import { toastSuccess } from "../../../../components/base/Toast";



export default function BalanceTransactionsList() {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    })

    const hub = useHub()

    const [createTransaction, createTransactionSet] = useState<boolean>(false)
    const [editTransaction, editTransactionSet] = useState<boolean>(false)
    const [deleteTransaction, deleteTransactionSet] = useState<boolean>(false)
    const [selectedTransaction, selectedTransactionSet] = useState<BalanceTransaction>()

    useEffect(() => {
        setPage("Balance Transactions", "CRM", "Balance")

        return () => {
            setPage("")
            setToolbarActions(undefined)
        }
    }, [])


    const [refresh, refreshSet] = useState<boolean>();
    useEffect(() => {
        if (refresh) {
            setTimeout(() => {
                refreshSet(false);
            }, 1000);
        }
    }, [refresh])



    const AmountItem = (data: BalanceTransaction) => (
        <div className={`fw-bold fs-6 ${(data.type == BalanceTransactionTypes.Receive ? "text-success" : data.type == BalanceTransactionTypes.Pay ? "text-danger" : "text-gray-800")}`}>
            {(data.type == BalanceTransactionTypes.Receive ? "+" : "-")}
            {moneyFormatter.format(data.amount ?? 0)}
        </div>
    )

    const PartyItem = (data: BalanceTransaction) => (
        <div>
            {
                data.party == BalanceTransactionParties.Source &&
                <div>
                    <div>Source</div>
                    <FlexRow className="fs-8">
                        <Icon icon="bullhorn" className="me-1" />
                        {data.source?.name}
                    </FlexRow>
                </div>
            }
            {
                data.party == BalanceTransactionParties.Technician &&
                <div>
                    <div>Technician</div>
                    <FlexRow className="fs-8">
                        <Icon icon="user-helmet-safety" className="me-1" />
                        {data.tech?.fullName}
                    </FlexRow>
                </div>
            }
        </div>
    )

    const DescrItem = (data: BalanceTransaction) => (
        <div style={{ maxWidth: 250 }}>
            {data.description}
        </div>
    )

    const CreatedItem = (data: BalanceTransaction) => (
        <div>
            <div className='d-flex align-items-center'>
                {toPrettyDate(data.createdAt)}
            </div>
            {
                data.creatorUser &&
                <FlexRow className='fs-8 mt-1'>
                    <div>
                        <Icon icon="user" className="me-2" size={10} type="solid" />
                    </div>
                    <div className="fs-8">
                        By: {data.creatorUser.fullName}
                    </div>
                </FlexRow>
            }

        </div>
    )

    return (
        <div className="p-5">

                <DataTable
                    objectName="Transaction"
                    filteringProps={FilteringProps}
                    apiRoute={"/reports/balance/transactions"}
                    refresh={refresh} edit delete
                    addCustom={() => createTransactionSet(true)}
                    editCustom={item => {
                        editTransactionSet(true)
                        selectedTransactionSet(item)
                    }}
                    deleteCustom={item => {
                        deleteTransactionSet(true)
                        selectedTransactionSet(item)
                    }}>

                    <DataTableField title="Amount">
                        <AmountItem />
                    </DataTableField>

                    <DataTableField title="Party">
                        <PartyItem />
                    </DataTableField>

                    <DataTableField title="Description">
                        <DescrItem />
                    </DataTableField>

                    <DataTableField title="Created">
                        <CreatedItem />
                    </DataTableField>

                </DataTable>



            {
                createTransaction &&
                <TransactionForm key="tras-form-create"
                    onSave={() => refreshSet(true)}
                    onClose={() => createTransactionSet(false)} />
            }

            {
                editTransaction && selectedTransaction &&
                <TransactionForm key="tras-form-edit"
                    onSave={() => refreshSet(true)}
                    onClose={() => {
                        editTransactionSet(false)
                        selectedTransactionSet(undefined)
                    }}
                    item={selectedTransaction} />
            }

            {
                deleteTransaction && selectedTransaction &&
                <Modal id="modal-delete-transaction-row"
                    open visible
                    title={"Delete Transaction"}
                    onClose={() => {
                        deleteTransactionSet(false)
                        selectedTransactionSet(undefined)
                    }}
                    onConfirm={callback => {

                        hub.Post("/reports/balance/deletetransaction", {
                            id: selectedTransaction.id
                        }, res => {
                            if (res.success) {
                                toastSuccess("Transaction has been deleted successfully!")
                                refreshSet(true)
                            }
                            callback!()
                        })

                    }}
                    buttonText="Confirm & Delete"
                    buttonColor="danger">
                    <p className="ps-1">Are you sure you want to delete the selected Transaction?</p>

                    <FlexRow className="p-5 bg-light">
                        <div className="me-10">
                            <AmountItem {...selectedTransaction} />
                        </div>
                        <PartyItem {...selectedTransaction} />
                    </FlexRow>

                </Modal>
            }

        </div>
    )
}